import React, { useState, useEffect, useRef } from "react";

import {
  Box,
  Grid,
  Chip,
  Tooltip,
  Stack,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  RadioGroup,
  Radio,
  Tabs,
  Tab,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  InputAdornment,
  alpha,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PostAddIcon from "@mui/icons-material/PostAdd";
import CloseIcon from "@mui/icons-material/Close";
import { green, grey } from "@mui/material/colors";
import { useParams } from "react-router-dom";
import P2PNavbar from "./P2PNavbar";
import {
  P2PWEBSERVICE,
  WEBSERVICE,
  encryptMessages,
  showToast,
} from "../../CoreDataService";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTheme } from "@mui/material/styles";
import p2pWebSocketService from "./p2pWebSocketService";
// import EditSquareIcon from '@mui/icons-material/EditSquare';
import EditIcon from "@mui/icons-material/Edit";
import { useChat } from "../../Services/ChatService";
import axios from "axios";
import { use } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { ButtonGroup } from "react-bootstrap";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const steps = [
  "Set Type & Price",
  "Set Total Amount & Payment Method",
  "Set Remarks & Automatic Response",
];

const P2PPostAd = () => {
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    asset: "",
    fiat: "",
    priceType: "Fixed",
    floatingMargin: 0,
    price: "",
    totalAmount: "",
    orderLimitMin: "",
    orderLimitMax: "",
    remarks: "",
    autoReply: "",
    region: "",
    registeredDays: 1,
    holdingAmount: 1,
    status: "1",
    type: "buy",
    percentageFrom: 85,
    percentageTo: 120,
    percentageInput: "",
    paymentTimeLimit: "15",
  });
  const { makeUserOnline } = useChat();

  const [conversionRates, setConversionRates] = useState({});
  const [dropdownFiatList, setDropdownFiatList] = useState([]);
  const [counterCurrency, setCounterCurrency] = useState([]);

  const [wantToBuy, setWantToBuy] = useState("buy");
  const [sellAsset, setSellAsset] = useState("");
  const [sellFiat, setSellFiat] = useState("");
  const [buyAsset, setBuyAsset] = useState("");
  const [buyFiat, setBuyFiat] = useState("");
  const [sellPriceType, setSellPriceType] = useState("Fixed"); // or 'Floating'
  const [buyPriceType, setBuyPriceType] = useState("Fixed");
  const [marketPrice, setMarketPrice] = useState(0);
  const [highestPrice, setHighestPrice] = useState("");
  const [lowestPrice, setLowestPrice] = useState("");
  const [priceLowestRangeSell, setPriceLowestRangeSell] = useState("");
  const [priceHighestRangeSell, setPriceHighestRangeSell] = useState("");
  const [priceLowestRange, setPriceLowestRange] = useState("");
  const [priceHighestRange, setPriceHighestRange] = useState("");
  const [percentageInputSell, setPercentageInputSell] = useState(0);
  const [percentageInput, setPercentageInput] = useState(0);
  const [percentageFrom, setPercentageFrom] = useState(85); // example default
  const [percentageTo, setPercentageTo] = useState(120);
  const [percentageLowestRangeSell, setPercentageLowestRangeSell] = useState(
    formData.percentageFrom
  );
  const [percentageHighestRangeSell, setPercentageHighestRangeSell] = useState(
    formData.percentageTo
  );
  const [percentageLowestRange, setPercentageLowestRange] = useState(
    formData.percentageFrom
  );
  const [percentageHighestRange, setPercentageHighestRange] = useState(
    formData.percentageTo
  );
  const [yourPriceSell, setYourPriceSell] = useState(0);
  const [yourPrice, setYourPrice] = useState(0);
  const [stpLoader, setStpLoader] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const precision = 2; // or based on the selected asset
  const [bankTransferPaymentMethodList, setBankTransferPaymentMethodList] =
    useState([]);
  const [walletServicePaymentMethodList, setWalletServicePaymentMethodList] =
    useState([]);
  const [paymentCreateModal, setPaymentCreateModal] = useState(false);
  const [createPaymentMethod, setCreatePaymentMethod] = useState("");
  const [paymentProviderNameCreate, setPaymentProviderNameCreate] =
    useState("");
  const [phoneNumberCreate, setPhoneNumberCreate] = useState("");
  const [walletIdCreate, setWalletIdCreate] = useState("");
  const [emailIdCreate, setEmailIdCreate] = useState("");
  const [paymentEditModal, setPaymentEditModal] = useState(false);
  const [formValues, setFormValues] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [pmDetailsId, setPmDetailsId] = useState(null);
  const [editPaymentMethod, setEditPaymentMethod] = useState("");

  const [accountHolderNameEdit, setAccountHolderNameEdit] = useState("");
  const [paymentProviderNameEdit, setPaymentProviderNameEdit] = useState("");
  const [phoneNumberEdit, setPhoneNumberEdit] = useState("");
  const [walletIdEdit, setWalletIdEdit] = useState("");
  const [emailIdEdit, setEmailIdEdit] = useState("");

  const [accountNumberEdit, setAccountNumberEdit] = useState("");
  const [accountTypeEdit, setAccountTypeEdit] = useState("");
  const [identificationTypeEdit, setIdentificationTypeEdit] = useState("");
  const [routingNumberEdit, setRoutingNumberEdit] = useState("");
  const [bankNameEdit, setBankNameEdit] = useState("");
  const [bankAddressEdit, setBankAddressEdit] = useState("");
  const [selectedAccountType, setSelectedAccountType] = useState("");
  const [selectedCodeType, setSelectedCodeType] = useState("");
  const { userInfo, brokerBasicInfo } = useSelector((state) => state);
  const [paymentMethodsCount, setPaymentMethodsCount] = useState(3); // Example count
  const [selectedChildTab, setSelectedChildTab] = useState(0);
  const [floatingPrice, setFloatingPrice] = useState("");
  const [equivalentAmount, setEquivalentAmount] = useState("");

  const [
    currentSelectedWalletPaymentMethod,
    setCurrentSelectedWalletPaymentMethod,
  ] = useState([]);
  const [selectedWalletPaymentMethod, setSelectedWalletPaymentMethod] =
    useState([]);

  const [
    currentSelectedBankPaymentMethod,
    setCurrentSelectedBankPaymentMethod,
  ] = useState([]);
  const [selectedBankPaymentMethod, setSelectedBankPaymentMethod] = useState(
    []
  );
  const [checkboxStates, setCheckboxStates] = useState({});
  const [allRegion, setAllRegion] = useState([]);

  const [allSelectedPaymentMethod, setAllSelectedPaymentMethod] = useState([]);
  const [allPaymentMethod, setAllPaymentMethod] = useState([]);

  const [onAdPreviewModal, setOnAdPreviewModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedBankRows, setSelectedBankRows] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange", // Ensures real-time validation updates
    defaultValues: {
      accountHolder: "",
      ibanNumber: "",
      bankName: "",
      accountType: "",
      bankAddress: "",
      codeType: "",
      additionalCode: "",
    },
  });

  const handleChildTabChange = (event, newTab) => {
    setSelectedChildTab(newTab);
  };

  useEffect(() => {
    getAllFiat();
    getBasecurrencyList();
    getAllPaymentMethodByUser();
    getAllRegion();
  }, []);

  useEffect(() => {
    getP2PMarketPrice();
    updateYourPrice(floatingPrice);
  }, [formData.asset, formData.fiat, floatingPrice]);

  useEffect(() => {
    getP2PMarketPrice();
  }, [floatingPrice]);

  const getAllPaymentMethodByUser = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const accessToken = localStorage.getItem("access_token");

      const response = await axios.post(
        `${P2PWEBSERVICE}/getAllPaymentMethodByUser`,
        { uuid },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const { error, error_msg, paymentDetails } = response.data;

      if (error?.error_data === 0 && Array.isArray(paymentDetails)) {
        const bankMethods = [];
        const walletMethods = [];

        paymentDetails.forEach((method) => {
          if (method.paymentMethodName === "BANK TRANSFER") {
            let identificationType = "";
            let identificationNumber = "";

            if (method.ifscCode) {
              identificationType = "IFSC CODE";
              identificationNumber = method.ifscCode;
            } else if (method.swiftCode) {
              identificationType = "SWIFT CODE";
              identificationNumber = method.swiftCode;
            } else if (method.routingNo) {
              identificationType = "ROUTING NO";
              identificationNumber = method.routingNo;
            }

            bankMethods.push({
              accountHolderName: method.profileName,
              bankName: method.bankName,
              pmDetailsId: method.pmDetailsId,
              accountNo: method.accountNo,
              accountType: method.accountType,
              identificationType,
              identificationNumber,
              bankAddress: method.bankAddress,
            });
          } else {
            walletMethods.push({
              paymentProviderName: method.paymentProviderName,
              walletId: method.vpa,
              pmDetailsId: method.pmDetailsId,
              email_id: method.emailId,
              phone_number: method.mobileNo,
              profileName: method.profileName,
            });
          }
        });

        console.log(
          "BankTransferPaymentMethodList",
          bankTransferPaymentMethodList
        );
        console.log(
          "walletTransferPaymentMethodList",
          walletServicePaymentMethodList
        );

        setBankTransferPaymentMethodList(bankMethods);
        setWalletServicePaymentMethodList(walletMethods);
      } else {
        showToast("error", error_msg || "Failed to fetch payment methods");
        setBankTransferPaymentMethodList([]);
        setWalletServicePaymentMethodList([]);
      }
    } catch (error) {
      showToast("error", "Something went wrong while fetching payment methods");
      setBankTransferPaymentMethodList([]);
      setWalletServicePaymentMethodList([]);
    }
  };

  const handleOpenEditPaymentModal = (pmDetailsId, index, service) => {
    console.log("service", service);

    if (service === "wallet_services") {
      setAccountHolderNameEdit(
        walletServicePaymentMethodList[index].profileName
      );
      setPaymentProviderNameEdit(
        walletServicePaymentMethodList[index].paymentProviderName
      );
      setPhoneNumberEdit(walletServicePaymentMethodList[index].phone_number);
      setWalletIdEdit(walletServicePaymentMethodList[index].walletId);
      setEmailIdEdit(walletServicePaymentMethodList[index].email_id);
      setEditPaymentMethod("Wallet Services");
    } else {
      setAccountHolderNameEdit(
        bankTransferPaymentMethodList[index].accountHolderName
      );
      setAccountNumberEdit(bankTransferPaymentMethodList[index].accountNo);
      setAccountTypeEdit(bankTransferPaymentMethodList[index].accountType);
      setIdentificationTypeEdit(
        bankTransferPaymentMethodList[index].identificationType
      );
      setRoutingNumberEdit(
        bankTransferPaymentMethodList[index].identificationNumber
      );
      setBankNameEdit(bankTransferPaymentMethodList[index].bankName);
      setBankAddressEdit(bankTransferPaymentMethodList[index].bankAddress);

      setValue(
        "accountHolder",
        bankTransferPaymentMethodList[index].accountHolderName || ""
      );
      setValue(
        "ibanNumber",
        bankTransferPaymentMethodList[index].accountNo || ""
      );

      setValue("bankName", bankTransferPaymentMethodList[index].bankName || "");
      setValue(
        "accountType",
        bankTransferPaymentMethodList[index].accountType || "Personal Savings"
      );
      setSelectedAccountType(bankTransferPaymentMethodList[index].accountType);
      setValue(
        "bankAddress",
        bankTransferPaymentMethodList[index].bankAddress || ""
      );

      setValue(
        "codeType",
        bankTransferPaymentMethodList[index].identificationType
      );
      setSelectedCodeType(
        bankTransferPaymentMethodList[index].identificationType
      );
      setValue(
        "additionalCode",
        bankTransferPaymentMethodList[index].identificationNumber
      );
      console.log(
        "additionalCode",
        bankTransferPaymentMethodList[index].identificationNumber
      );

      setEditPaymentMethod("Bank Transfer");
    }

    console.log("heell");

    setPmDetailsId(pmDetailsId);
    setPaymentEditModal(true); // Show the modal
  };

  const validateBankCode = (code) => {
    if (!code) return "Required";
    const type = watch("codeType");
    let reg;
    if (type === "ROUTING NO") {
      reg = /^\d{9}$/gm;
      return reg.test(code)
        ? true
        : "Invalid Routing Number (9 digits required)";
    } else if (type === "SWIFT CODE") {
      reg = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/gm;
      return reg.test(code) ? true : "Invalid SWIFT Code";
    } else if (type === "IFSC CODE") {
      reg = /^[A-Z]{4}0[A-Z0-9]{6}$/gm;
      return reg.test(code) ? true : "Invalid IFSC Code";
    }
    return "Invalid Code";
  };

  const allowPhoneNumber = (e) => {
    const key = e.key;
    const value = e.target.value;

    // allow control keys
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }

    // allow '+' only if it's the first character
    if (key === "+" && value.length === 0) {
      return;
    }

    // allow only digits
    const regex = /^[0-9]$/;
    if (!regex.test(key)) {
      e.preventDefault(); // block anything that's not a digit or allowed +
    }
  };

  const allowOnlyAlphabets = (e) => {
    const key = e.key;
    // allow backspace, tab, arrows, delete
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    // allow letters and space
    const regex = /^[a-zA-Z\s]$/;
    if (!regex.test(key)) {
      e.preventDefault(); // block invalid char
    }
  };
  const handlePasteOnlyAlpha = (e) => {
    const pasteData = e.clipboardData.getData("text");
    const regex = /^[a-zA-Z\s]$/;

    if (!regex.test(pasteData)) {
      e.preventDefault(); // block invalid pasted content
    }
  };
  const allowOnlyAlphaNum = (e) => {
    const key = e.key;
    // allow backspace, tab, arrows, delete
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    // allow letters and space
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (!regex.test(key)) {
      e.preventDefault(); // block invalid char
    }
  };

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text");
    const regex = /^[a-zA-Z0-9 ]*$/;

    if (!regex.test(pasteData)) {
      e.preventDefault(); // block invalid pasted content
    }
  };

  const allowEmail = (e) => {
    const key = e.key;

    // allow control keys
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }

    // regex: letters, numbers, @ . _ -
    const regex = /^[a-zA-Z0-9@._-]$/;
    if (!regex.test(key)) {
      e.preventDefault(); // block anything not allowed
    }
  };

  const updateBankDetails = async () => {
    const formValues = watch();
    console.log("formValues.accountType", formValues);

    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "UPDATE",
      transferType: 2,
      paymentMethodName: "BANK TRANSFER",
      profileName: formValues.accountHolder,
      accountNo: formValues.ibanNumber,
      accountType: formValues.accountType,
      bankName: formValues.bankName,
      bankAddress: formValues.bankAddress,
      pmDetailsId: pmDetailsId,
    };

    switch (formValues.codeType) {
      case "ROUTING NO":
        payload.routingNo = formValues.additionalCode;
        break;
      case "IFSC CODE":
        payload.ifscCode = formValues.additionalCode;
        break;
      case "SWIFT CODE":
        payload.swiftCode = formValues.additionalCode;
        break;
      default:
        break;
    }
    // console.log('payload',payload);

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");

        setTimeout(() => {
          // Close modal and reset state
          setPaymentEditModal(false);
          setPmDetailsId("");
          setAccountHolderNameEdit("");
          setAccountNumberEdit("");
          setAccountTypeEdit("");
          setIdentificationTypeEdit("");
          setRoutingNumberEdit("");
          setBankNameEdit("");
          setBankAddressEdit("");

          getAllPaymentMethodByUser(); // Refresh list
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "An error occurred while updating the payment method");
      console.error("Update error:", error);
    }
  };

  const updateWalletDetails = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "UPDATE",
      transferType: 1,
      paymentMethodName: "WALLET SERVICE",
      profileName: accountHolderNameEdit,
      mobileNo: phoneNumberEdit,
      vpa: walletIdEdit,
      emailId: emailIdEdit,
      paymentProviderName: paymentProviderNameEdit,
      pmDetailsId: pmDetailsId,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");

        setTimeout(() => {
          // Close modal and reset form
          setPaymentEditModal(false); // assumes you’re using state to control modal visibility
          setPmDetailsId("");
          setPaymentProviderNameEdit("");
          setPhoneNumberEdit("");
          setWalletIdEdit("");
          setEmailIdEdit("");
          setAccountHolderNameEdit("");

          getAllPaymentMethodByUser(); // Refresh list
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "Failed to update payment method");
      console.error("Error updating wallet details:", error);
    }
  };

  const createWalletDetails = async () => {
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    const payload = {
      uuid,
      action: "INSERT",
      transferType: 1,
      paymentMethodName: "WALLET SERVICE",
      profileName: userInfo.userResult.firstName + userInfo.userResult.lastName,
      mobileNo: phoneNumberCreate,
      vpa: walletIdCreate,
      emailId: emailIdCreate,
      paymentProviderName: paymentProviderNameCreate,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/addUserPaymentMethod`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const { error_data, error_msg } = response.data;

      if (error_data === 0) {
        showToast("success", "Payment Method updated successfully");
        setPaymentCreateModal(false);
        setTimeout(() => {
          // Close modal and reset form
          setPaymentEditModal(false); // assumes you’re using state to control modal visibility
          setPmDetailsId("");
          setPaymentProviderNameCreate("");
          setPhoneNumberCreate("");
          setWalletIdCreate("");
          setEmailIdCreate("");

          getAllPaymentMethodByUser(); // Refresh list
        }, 2000);
      } else {
        showToast("error", error_msg);
      }
    } catch (error) {
      showToast("error", "Failed to update payment method");
      console.error("Error updating wallet details:", error);
    }
  };

  const createBankDetails = async () => {
    // if (!data.accountHolder || !data.bankName || !data.ibanNumber || !data.additionalCode || !data.bankAddress || !data.accountType) {
    //   showToast("warning", "You have not made any changes");
    //   return;
    // }
    const formValues = watch();

    if (
      formValues.bankName == "" ||
      formValues.ibanNumber == "" ||
      formValues.bankAddress == "" ||
      formValues.accountType == ""
    ) {
      showToast("warning", "Please fill all the fields");
    } else {
      console.log("formValues.accountType", formValues.accountType);

      const updateBankObj = {
        uuid: localStorage.getItem("uuid"),
        action: "INSERT",
        transferType: 2,
        paymentMethodName: "BANK TRANSFER",
        profileName: formValues.accountHolder,
        bankName: formValues.bankName,
        accountNo: formValues.ibanNumber,
        bankAddress: formValues.bankAddress,
        accountType: formValues.accountType,
      };

      switch (formValues.codeType) {
        case "ROUTING NO":
          updateBankObj["routing_no"] = formValues.additionalCode;
          break;
        case "IFSC CODE":
          updateBankObj["ifscCode"] = formValues.additionalCode;
          break;
        case "SWIFT CODE":
          updateBankObj["swiftCode"] = formValues.additionalCode;
          break;
        case "IBAN NO":
          updateBankObj["ibanNo"] = formValues.additionalCode;
          break;
        default:
          break;
      }

      try {
        const response = await axios.post(
          P2PWEBSERVICE + "/addUserPaymentMethod",
          JSON.stringify(updateBankObj),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "BEARER " + localStorage.getItem("access_token"),
            },
          }
        );

        const { error_data, error_msg } = response.data;

        console.log(error_data, error_msg);
        console.log("response.data", response.data);

        if (error_data === 0) {
          showToast("success", "Payment Method added sucessfully");
          setPaymentCreateModal(false);
          getAllPaymentMethodByUser();
        } else {
          showToast("error", error_msg);
        }
      } catch (error) {
        if (error.response?.status === 401) {
        }
      }
    }
  };

  const deletePaymentMethod = async (pmDetailsId, type) => {
    let pm = "";
    let trtype = null;

    if (type === "wallet_service") {
      pm = "WALLET SERVICE";
      trtype = 1;
    } else if (type === "bank_transfer") {
      pm = "BANK TRANSFER";
      trtype = 2;
    }

    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      action: "DELETE",
      pmDetailsId: pmDetailsId,
      paymentMethodName: pm,
      transferType: trtype,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/updateAndDeletePaymentMethod`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const apiMessage = response.data.error_data;
      const apiMessageText = response.data.error_msg;

      if (apiMessage === 0) {
        showToast("success", "Payment Method deleted successfully");
        setTimeout(() => {
          getAllPaymentMethodByUser();
        }, 2000);
      } else {
        showToast("error", apiMessageText);
      }
    } catch (error) {
      console.error("Error deleting payment method:", error);
      showToast(
        "error",
        "An error occurred while deleting the payment method."
      );
    }
  };

  const handlePaymentEditDialogClose = () => {
    setPaymentEditModal(false);
  };

  const getAllFiat = async () => {
    try {
      const response = await axios.get(
        "https://v6.exchangerate-api.com/v6/780e118e654b80b4f67594ed/latest/USD"
      );
      const rates = response.data.conversion_rates;
      setConversionRates(rates);
      setDropdownFiatList(Object.keys(rates));
    } catch (error) {
      console.error("Failed to fetch fiat data:", error);
    }
  };

  const getAllRegion = async () => {
    try {
      const response = await axios.get(P2PWEBSERVICE + "/getAllRegions");
      const regions = response.data.regions;
      setAllRegion(regions);
    } catch (error) {
      console.error("Failed to fetch fiat data:", error);
    }
  };

  const getBasecurrencyList = async () => {
    const brokerId = localStorage.getItem("BROKERID");
    const accessToken = localStorage.getItem("access_token");

    try {
      const response = await axios.get(
        `${WEBSERVICE}home/getAllCurrency/${brokerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${accessToken}`,
          },
        }
      );

      const result = response.data;
      setCounterCurrency(result.currencyList); // Store the currency list in state
    } catch (error) {
      // Handle errors
      if (error.response) {
        showToast("error", `${error.response.status}`);
        console.error(
          "Error fetching base currency list:",
          error.response.data
        );
      } else {
        showToast("error", "An unexpected error occurred");
        console.error("Unexpected error:", error);
      }
    }
  };

  const getP2PMarketPrice = async () => {
    let asset = "";
    let fiat = "";
    let type = null;

    if (formData.type === "sell") {
      if (!formData.asset || !formData.fiat) {
        // showToast('error', 'Please choose an asset and fiat');
        return;
      }
      asset = formData.asset;
      fiat = formData.fiat;
      type = 2;
    } else {
      if (!formData.asset || !formData.fiat) {
        // showToast('error', 'Please choose an asset and fiat');
        return;
      }
      asset = formData.asset;
      fiat = formData.fiat;
      type = 1;
    }

    setStpLoader(true);

    try {
      const response = await axios.get(
        `${P2PWEBSERVICE}/getP2PMarketPrice/${asset}/${fiat}/${type}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      setStpLoader(false);
      const { error, highestPrice, lowestPrice, marketPrice } = response.data;
      const apiMessage = error?.error_data;
      const apiMessageText = error?.error_msg;

      if (apiMessage === 0) {
        setApiCalled(true);
        console.log("formData.type", formData.type);
        console.log("formData.priceType", formData.priceType);

        if (formData.type === "sell") {
          if (formData.priceType === "Fixed") {
            setHighestPrice(Number(highestPrice).toFixed(precision));
            setPriceLowestRangeSell(
              Number(marketPrice * 0.85).toFixed(precision)
            );
            setPriceHighestRangeSell(
              Number(marketPrice * 1.2).toFixed(precision)
            );
          } else {
            setLowestPrice(Number(lowestPrice).toFixed(precision));
            const msell = Number(Number(marketPrice).toFixed(precision));
            setMarketPrice(msell);
            setPercentageLowestRangeSell(Number(formData.percentageFrom));
            setPercentageHighestRangeSell(Number(formData.percentageTo));
            setYourPriceSell(msell * (formData.percentageInputSell / 100));
          }
        } else {
          if (formData.priceType == "Fixed") {
            console.log("highestPrice", highestPrice);

            setHighestPrice(Number(highestPrice).toFixed(precision));
            setPriceLowestRange(Number(marketPrice * 0.85).toFixed(precision));
            setPriceHighestRange(Number(marketPrice * 1.2).toFixed(precision));
          } else {
            console.log("highestPrice", highestPrice);

            setLowestPrice(Number(lowestPrice).toFixed(precision));
            const mbuy = Number(Number(marketPrice).toFixed(precision));
            setMarketPrice(mbuy);
            console.log("setMarketPrice", marketPrice);

            setPercentageLowestRange(Number(formData.percentageFrom));
            setPercentageHighestRange(Number(formData.percentageTo));
            setYourPrice(mbuy * (formData.percentageInput / 100));
          }
        }
      } else {
        showToast("error", apiMessageText || "API Error");
      }
    } catch (error) {
      setStpLoader(false);
      showToast("error", "Failed to fetch P2P market price");
    }
  };

  const updateYourPrice = async (input) => {
    setFloatingPrice(input);

    let asset = "";
    let fiat = "";
    let type = null;

    if (formData.type === "sell") {
      if (!formData.asset || !formData.fiat) {
        // showToast('error', 'Please choose an asset and fiat');
        return;
      }
      asset = formData.asset;
      fiat = formData.fiat;
      type = 2;
    } else {
      if (!formData.asset || !formData.fiat) {
        // showToast('error', 'Please choose an asset and fiat');
        return;
      }
      asset = formData.asset;
      fiat = formData.fiat;
      type = 1;
    }

    setStpLoader(true);

    try {
      const response = await axios.get(
        `${P2PWEBSERVICE}/getP2PMarketPrice/${asset}/${fiat}/${type}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      setStpLoader(false);
      const { error, highestPrice, lowestPrice, marketPrice } = response.data;
      const apiMessage = error?.error_data;
      const apiMessageText = error?.error_msg;

      if (formData.type == "buy") {
        if (input > percentageLowestRange && input < percentageHighestRange) {
          var yourPrice = Number(
            (marketPrice * (input / 100)).toFixed(precision)
          );
          setFormData((prev) => ({ ...prev, price: yourPrice }));
          console.log("hreee", marketPrice, yourPrice);

          // this.data.alert('Percentage is in a valid range', 'success');
        } else {
          console.log(
            "hreee33",
            input,
            percentageLowestRange,
            percentageHighestRange
          );

          // showToast('error', `should be between ${percentageLowestRange} and ${percentageHighestRange}`)
        }
      } else {
        if (
          input > percentageLowestRangeSell &&
          input < percentageHighestRangeSell
        ) {
          var yourPrice = Number(
            (marketPrice * (input / 100)).toFixed(precision)
          );
          setFormData((prev) => ({ ...prev, price: yourPrice }));
          console.log("hreee2");

          // this.data.alert('Percentage is in a valid range', 'success');
        } else {
          console.log("hreeepppp");
        }
      }
    } catch {}
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("check", e);

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (value == "Floating") {
      var datass = Number(formData.percentageFrom);
      datass = datass + 1;
      setFormData((prev) => ({ ...prev, floatingMargin: datass }));
      console.log("gggg");

      updateYourPrice(datass);
    }
  };

  const handleNext = () => {
    if (activeStep == 1) {
      const allSelectedPaymentMethod = [];
      const allPaymentMethod = [];

      selectedBankPaymentMethod.forEach((paymentMethod) => {
        allSelectedPaymentMethod.push(paymentMethod.pmDetailsId);
        allPaymentMethod.push(paymentMethod.bankName);
      });

      selectedWalletPaymentMethod.forEach((paymentMethod) => {
        allSelectedPaymentMethod.push(paymentMethod.pmDetailsId);
        allPaymentMethod.push(paymentMethod.paymentProviderName);
      });

      // Optional: set state if you're managing it via useState
      setAllSelectedPaymentMethod(allSelectedPaymentMethod);
      setAllPaymentMethod(allPaymentMethod);
    } else if (activeStep == 2) {
      setOnAdPreviewModal(true);
    }

    if (activeStep < steps.length - 1) setActiveStep((prev) => prev + 1);
  };

  const isStepValid = () => {
    if (activeStep === 0) {
      const { type, asset, fiat, priceType, price, floatingMargin } = formData;

      if (!type || !asset || !fiat || !priceType) return false;

      if (priceType === "Fixed") {
        return (
          price &&
          Number(price) >= priceLowestRange &&
          Number(price) <= priceHighestRange
        );
      } else {
        return (
          floatingMargin &&
          Number(floatingMargin) >= percentageLowestRange &&
          Number(floatingMargin) <= percentageHighestRange
        );
      }
    }

    if (activeStep === 1) {
      const { totalAmount, orderLimitMin, orderLimitMax } = formData;
      const total = parseFloat(totalAmount);
      const min = parseFloat(orderLimitMin);
      const max = parseFloat(orderLimitMax);

      const hasPaymentMethod =
        selectedWalletPaymentMethod.length > 0 ||
        selectedBankPaymentMethod.length > 0;

      console.log("total", total);
      console.log("min", min);
      console.log("max", max);
      console.log("hasPaymentMethod", hasPaymentMethod);

      if (min >= max) {
        showToast("error", "Min value must be less than max value");
      } else {
      }

      return total > 0 && min > 0 && max > 0 && min < max && hasPaymentMethod;
    }

    if (activeStep === 2) {
      const { region, registeredDays, holdingAmount, status } = formData;

      return (
        region?.trim() &&
        registeredDays !== "" &&
        holdingAmount !== "" &&
        status !== ""
      );
    }

    // Assume all other steps are valid for now
    return true;
  };

  const handleCreateAd = async () => {
    const jsonObj = {
      adType: formData.type.toUpperCase(),
    };
    var asset = formData.asset;
    var fiat = formData.fiat;
    var priceType = formData.priceType;

    if (formData.priceType === "Fixed") {
      var price = formData.price;
      var percentage = 0;
    } else {
      var price = formData.price;
      var percentage = formData.floatingMargin;
    }

    var amount = formData.totalAmount;
    var maxOrderLimit = formData.orderLimitMax;
    var minOrderLimit = formData.orderLimitMin;
    var paymentTimeLimit = formData.paymentTimeLimit;
    var remarks = formData.remarks;
    var autoReply = formData.autoReply;
    var region = formData.region;
    var registeredDays = formData.registeredDays;
    var totalHoldings = formData.holdingAmount;
    var onlineOfflineStatus = formData.status;

    const paymentObj = {
      action: "INSERT",
      uuid: localStorage.getItem("uuid"),
      pmDetailsId: allSelectedPaymentMethod.toString(),
    };

    Object.assign(jsonObj, {
      crypto: asset,
      fiat,
      priceType,
      price: price.toString(),
      amount: amount.toString(),
      paymentTimeLimit: +paymentTimeLimit,
      maxOrderLimit: +maxOrderLimit,
      minOrderLimit: +minOrderLimit,
      remarks,
      autoReply,
      region,
      registeredDays,
      totalHoldings,
      onlineOfflineStatus,
      paymentDetails: paymentObj,
      percentage: Number(percentage),
    });

    console.log("jsonObj", jsonObj);

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/postBuySellAd`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      setStpLoader(false);

      const res = response.data;
      const apiMessage = res.error?.error_data;
      const apiMessageText = res.error?.error_msg;

      if (apiMessage === 0) {
        showToast("success", "Ad created successfully");
        // makeUserOnline({
        //   userId: encryptMessages(localStorage.getItem("userId")),
        // });
        setOnAdPreviewModal(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        showToast("error", apiMessageText || "Something went wrong");
      }
    } catch (err) {
      setStpLoader(false);
      showToast("error", err.message || "Network error");
    }
  };

  const handleBack = () => {
    if (activeStep > 0) setActiveStep((prev) => prev - 1);
  };

  const getFiatPriceByCrypto = async (input) => {
    if (input == "") {
    } else {
      let asset = "";
      let fiat = "";
      let amount = 0;

      if (formData.type === "sell") {
        if (!formData.asset || !formData.fiat) {
          // alert('please choose an asset and fiat', 'danger');
          return;
        }
        asset = formData.asset;
        fiat = formData.fiat;
        amount = input;
      } else {
        if (!formData.asset || !formData.fiat) {
          // alert('please choose an asset and fiat', 'danger');
          return;
        }
        asset = formData.asset;
        fiat = formData.fiat;
        amount = input;
      }

      const payload = {
        crypto: asset,
        fiat: fiat,
        amount: amount,
      };

      var quivData = amount * marketPrice;

      setEquivalentAmount(quivData);

      // try {
      //     const response = await axios.post(
      //         `${P2PWEBSERVICE}/getFiatPriceByCrypto`,
      //         JSON.stringify(payload),
      //         {
      //             headers: {
      //                 'Content-Type': 'application/json',
      //                 'authorization': 'BEARER ' + localStorage.getItem('access_token'),
      //             },
      //         }
      //     );

      //     const res = response.data;
      //     if (res.error?.error_data === 0) {
      //         const value = Number(res.totalValue.toFixed(precision));
      //         setEquivalentAmount(value);

      //     } else {
      //         showToast('error', res.error?.error_msg || 'Something went wrong');
      //     }
      // } catch (err) {
      //     showToast('error', err?.message || 'API error');
      // }
    }
  };

  const addWalletPaymentMethod = (i) => {
    setCurrentSelectedWalletPaymentMethod((prev) => {
      const existingIndex = prev.findIndex((item) => item.currentIndex === i);
      let updatedCurrent = [...prev];
      let updatedSelected = [...selectedWalletPaymentMethod];
      const checkboxKey = "wallet" + i;

      if (existingIndex !== -1) {
        updatedCurrent.splice(existingIndex, 1);
        const selectedIndex = updatedSelected.findIndex(
          (item) =>
            item.pmDetailsId === walletServicePaymentMethodList[i].pmDetailsId
        );
        if (selectedIndex !== -1) {
          updatedSelected.splice(selectedIndex, 1);
        }
      } else {
        updatedCurrent.push({ currentIndex: i });
        updatedSelected.push({
          pmDetailsId: walletServicePaymentMethodList[i].pmDetailsId,
          paymentProviderName:
            walletServicePaymentMethodList[i].paymentProviderName,
        });
      }

      setSelectedWalletPaymentMethod(updatedSelected);
      setCheckboxStates((prev) => ({
        ...prev,
        [checkboxKey]: !prev[checkboxKey],
      }));
      console.log("updatedCurrent", selectedWalletPaymentMethod);

      return updatedCurrent;
    });
  };

  const handleSelectRowWallet = (i) => {
    const ad = walletServicePaymentMethodList[i];
    const adId = ad.pmDetailsId;

    const isAlreadySelected = selectedRows.includes(adId);
    let updatedSelectedRows;

    if (isAlreadySelected) {
      updatedSelectedRows = selectedRows.filter(
        (pmDetailsId) => pmDetailsId !== adId
      );
    } else {
      updatedSelectedRows = [...selectedRows, adId];
    }

    setSelectedRows(updatedSelectedRows);
  };
  const handleSelectRowBank = (i) => {
    const ad = bankTransferPaymentMethodList[i];
    const adId = ad.pmDetailsId;

    const isAlreadySelected = selectedBankRows.includes(adId);
    let updatedSelectedBankRows;

    if (isAlreadySelected) {
      updatedSelectedBankRows = selectedBankRows.filter(
        (pmDetailsId) => pmDetailsId !== adId
      );
    } else {
      updatedSelectedBankRows = [...selectedBankRows, adId];
    }

    setSelectedBankRows(updatedSelectedBankRows);
  };

  const addBankPaymentMethod = (i) => {
    setCurrentSelectedBankPaymentMethod((prev) => {
      const existingIndex = prev.findIndex((item) => item.currentIndex === i);
      let updatedCurrent = [...prev];
      let updatedSelected = [...selectedBankPaymentMethod];
      const checkboxKey = "bank" + i;

      if (existingIndex !== -1) {
        updatedCurrent.splice(existingIndex, 1);
        const selectedIndex = updatedSelected.findIndex(
          (item) =>
            item.pmDetailsId === bankTransferPaymentMethodList[i].pmDetailsId
        );
        if (selectedIndex !== -1) {
          updatedSelected.splice(selectedIndex, 1);
        }
      } else {
        updatedCurrent.push({ currentIndex: i });
        updatedSelected.push({
          pmDetailsId: bankTransferPaymentMethodList[i].pmDetailsId,
          bankName: bankTransferPaymentMethodList[i].bankName,
        });
      }

      setSelectedBankPaymentMethod(updatedSelected);
      // setCheckboxStates(prev => ({
      //     ...prev,
      //     [checkboxKey]: !prev[checkboxKey],
      // }));

      return updatedCurrent;
    });
  };

  const BankDetail = ({ label, value }) => (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      gap={0.1}
      sx={{
        border: "1px solid rgba(125,125,125,0.2)",
        p: 1,
        m: 0,
        fontSize: "10px",
        borderRadius: "5px",
        width: "100%",
        backgroundColor: "var(--body-color-less2)",
      }}
    >
      <Typography sx={{ whiteSpace: "nowrap", color: "var(--text-color)", opacity: 0.7 }}>{label}:</Typography>
      <Typography
        sx={{
          textAlign: "right",
          color: label === "Type" ? (value === "BUY" ? "#22c55e" : "#ef4444") : "var(--text-color)",
        }}
      >
        {value}
      </Typography>
    </Box>
  );

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            <Typography sx={{ fontSize: "1.1rem", fontWeight: 700, color: "var(--text-color)", mb: 1 }} gutterBottom>
              Trade Type & Pricing
            </Typography>
            <Divider sx={{ mb: 1, borderColor: "rgba(125,125,125,0.15)" }} />

            <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
              <Button
                variant={formData.type === "buy" ? "contained" : "outlined"}
                onClick={() =>
                  setFormData((prev) => ({ ...prev, type: "buy" }))
                }
                sx={{
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  bgcolor: formData.type === "buy" ? btncolor : "transparent",
                  borderColor: btncolor,
                  color: formData.type === "buy" ? "#fff" : btncolor,
                  "&:hover": {
                    bgcolor: formData.type === "buy" ? btncolor : alpha(btncolor || "#1976d2", 0.1),
                  },
                }}
              >
                I want to Buy
              </Button>
              <Button
                variant={formData.type === "sell" ? "contained" : "outlined"}
                onClick={() =>
                  setFormData((prev) => ({ ...prev, type: "sell" }))
                }
                sx={{
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  bgcolor: formData.type === "sell" ? btncolor : "transparent",
                  borderColor: btncolor,
                  color: formData.type === "sell" ? "#fff" : btncolor,
                  "&:hover": {
                    bgcolor: formData.type === "sell" ? btncolor : alpha(btncolor || "#1976d2", 0.1),
                  },
                }}
              >
                I want to Sell
              </Button>
            </Box>

            <Grid container spacing={3}>
              <Grid size={6}>
                <FormControl fullWidth sx={modernSelectStyle}>
                  <InputLabel>Asset</InputLabel>
                  <Select
                    name="asset"
                    value={formData.asset}
                    onChange={handleChange}
                    label="Asset"
                  >
                    {counterCurrency.map((currency) => (
                      <MenuItem value={currency}>{currency}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={6}>
                <FormControl fullWidth sx={modernSelectStyle}>
                  <InputLabel>Fiat Currency</InputLabel>
                  <Select
                    name="fiat"
                    value={formData.fiat}
                    onChange={handleChange}
                    label="Fiat Currency"
                  >
                    {dropdownFiatList.map((currency) => (
                      <MenuItem value={currency}>{currency}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid size={12}>
                <Typography sx={{ fontSize: "0.9rem", fontWeight: 600, color: "var(--text-color)", mb: 0.5 }} gutterBottom>
                  Price Type
                </Typography>
                <RadioGroup
                  row
                  value={formData.priceType}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  name="priceType"
                  sx={{ "& .MuiFormControlLabel-label": { color: "var(--text-color)" }, "& .MuiRadio-root": { color: "rgba(125,125,125,0.5)" }, "& .MuiRadio-root.Mui-checked": { color: btncolor } }}
                >
                  <FormControlLabel
                    value="Fixed"
                    control={<Radio />}
                    label="Fixed Price"
                  />
                  <FormControlLabel
                    value="Floating"
                    control={<Radio />}
                    label="Floating Margin"
                  />
                </RadioGroup>
              </Grid>

              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Your Price"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  type="number"
                  disabled={formData.priceType === "Floating"}
                  sx={modernFieldStyle}
                  helperText={
                    formData.priceType === "Fixed"
                      ? `Margin must be between ${priceLowestRange} ${formData.fiat} and ${priceHighestRange} ${formData.fiat}`
                      : ""
                  }
                />
              </Grid>
              <Grid size={6}>
                {formData.priceType === "Fixed" ? (
                  <Typography mt={2} sx={{ color: "var(--text-color)", opacity: 0.6 }}>
                    Highest Order Price: {highestPrice} {formData.fiat}
                  </Typography>
                ) : (
                  <Typography mt={2} sx={{ color: "var(--text-color)", opacity: 0.6 }}>
                    Lowest Order Price: {lowestPrice} {formData.fiat}
                  </Typography>
                )}
              </Grid>

              {formData.priceType === "Fixed" ? (
                ""
              ) : (
                <Grid size={6}>
                  <TextField
                    fullWidth
                    label="Floating Margin (%)"
                    name="floatingMargin"
                    type="number"
                    value={formData.floatingMargin}
                    onChange={(e) => {
                      handleChange(e);
                      updateYourPrice(e.target.value);
                    }}
                    sx={modernFieldStyle}
                    helperText={`Margin must be between ${percentageLowestRange}% and ${percentageHighestRange}%`}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            size="small"
                            onClick={() => {
                              const newValue = Math.max(
                                Number(formData.floatingMargin) - 1,
                                percentageLowestRange
                              );
                              handleChange({
                                target: {
                                  name: "floatingMargin",
                                  value: newValue,
                                },
                              });
                              updateYourPrice(newValue);
                            }}
                            sx={{
                              backgroundColor: "rgba(239,68,68,0.1)",
                              borderRadius: 1,
                              mr: 1,
                              "&:hover": { backgroundColor: "rgba(239,68,68,0.2)" },
                            }}
                          >
                            <RemoveIcon
                              fontSize="small"
                              sx={{ color: "#d32f2f" }}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => {
                              const newValue = Math.min(
                                Number(formData.floatingMargin) + 1,
                                percentageHighestRange
                              );
                              handleChange({
                                target: {
                                  name: "floatingMargin",
                                  value: newValue,
                                },
                              });
                              updateYourPrice(newValue);
                            }}
                            sx={{
                              backgroundColor: "rgba(34,197,94,0.1)",
                              borderRadius: 1,
                              ml: 1,
                              "&:hover": { backgroundColor: "rgba(34,197,94,0.2)" },
                            }}
                          >
                            <AddIcon
                              fontSize="small"
                              sx={{ color: "#2e7d32" }}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </>
        );

      case 1:
        return (
          <>
            <Typography sx={{ fontSize: "1.1rem", fontWeight: 700, color: "var(--text-color)", mb: 1 }} gutterBottom>
              Set Amount & Payment Method
            </Typography>
            <Divider sx={{ mb: 3, borderColor: "rgba(125,125,125,0.15)" }} />

            <Grid container spacing={3}>
              <Grid size={12}>
                <TextField
                  fullWidth
                  label={`Total Amount (${formData.asset})`}
                  name="totalAmount"
                  type="number"
                  value={formData.totalAmount}
                  placeholder="0"
                  onChange={(e) => {
                    handleChange({
                      target: { name: "totalAmount", value: e.target.value },
                    });
                    getFiatPriceByCrypto(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={modernFieldStyle}
                  helperText={`≈${equivalentAmount} ${formData.fiat}`}
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  fullWidth
                  label={`Min Order Limit (${formData.fiat})`}
                  name="orderLimitMin"
                  type="number"
                  placeholder="0"
                  value={formData.orderLimitMin}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={modernFieldStyle}
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  fullWidth
                  label={`Max Order Limit (${formData.fiat})`}
                  name="orderLimitMax"
                  type="number"
                  placeholder="1"
                  value={formData.orderLimitMax}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={modernFieldStyle}
                />
              </Grid>
              <Grid size={4}>
                <FormControl fullWidth sx={modernSelectStyle}>
                  <InputLabel>Payment Time Limit (in Mins)</InputLabel>
                  <Select
                    name="paymentTimeLimit"
                    value={formData.paymentTimeLimit}
                    onChange={handleChange}
                    label="Payment Time Limit (in Mins)"
                  >
                    <MenuItem value="">Select</MenuItem>
                    <MenuItem value="15">15</MenuItem>
                    <MenuItem value="20">20</MenuItem>
                    <MenuItem value="25">25</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid size={12}>
                                <Button variant="outlined">+ Add Payment Method</Button>
                            </Grid> */}

              <Grid size={12}>
                {/* <Typography variant="subtitle2">Added Payment Methods:</Typography>
                                <Box mt={1} p={2} bgcolor="grey.100" borderRadius={2}>
                                    <Typography>• UPI3 - upi3@upi.com</Typography>
                                    <Typography>• UPI2 - 544565646465654@ok-sbi</Typography>
                                    <Typography>• Test - 12233333333</Typography>
                                </Box> */}

                <Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box sx={{ maxWidth: "70%" }}>
                      <Typography sx={{ fontSize: "1.1rem", fontWeight: 700, color: "var(--text-color)", mb: 1 }}>P2P Payment Methods</Typography>
                      <Typography sx={{ color: "var(--text-color)", opacity: 0.65, fontSize: "0.85rem" }}>
                        P2P payment methods: When you sell cryptocurrencies, the
                        payment method added will be displayed to buyer as
                        options to accept payment, please ensure that the
                        account owner’s name is consistent with your verified
                        name on {brokerBasicInfo?.exchange}. You can add up to 5
                        payment methods.
                      </Typography>
                    </Box>

                    <ContainedButton
                      variant="contained"
                      disabled={paymentMethodsCount >= 5}
                      onClick={() => setPaymentCreateModal(true)}
                    >
                      + Add a Payment Method
                    </ContainedButton>
                    {paymentMethodsCount >= 5 && (
                      <Typography variant="body2" color="error">
                        You cannot add more than 5 payment methods!
                      </Typography>
                    )}
                  </Box>

                  <Box sx={{ mt: 3, backgroundColor: "var(--body-color-less)", border: "1px solid rgba(125,125,125,0.15)", borderRadius: "12px", overflow: "hidden" }}>
                    <Box sx={{ p: 2, borderBottom: "1px solid rgba(125,125,125,0.12)" }}>
                      <Typography sx={{ fontSize: "0.9rem", fontWeight: 600, color: "var(--text-color)" }}>
                        Total Payment Methods: {walletServicePaymentMethodList.length + bankTransferPaymentMethodList.length}
                      </Typography>
                    </Box>

                    <Tabs
                      value={selectedChildTab}
                      onChange={handleChildTabChange}
                      sx={{ "& .MuiTab-root": { color: "var(--text-color)", opacity: 0.6 }, "& .MuiTab-root.Mui-selected": { color: btncolor, opacity: 1 }, "& .MuiTabs-indicator": { backgroundColor: btncolor }, borderBottom: "1px solid rgba(125,125,125,0.12)" }}
                    >
                      <Tab
                        label={`Wallet Services (${walletServicePaymentMethodList.length})`}
                      />
                      <Tab
                        label={`Bank Transfer (${bankTransferPaymentMethodList.length})`}
                      />
                    </Tabs>

                    {/* Wallet Services Tab */}
                    {selectedChildTab === 0 && (
                      <Box sx={{ padding: 2 }}>
                        {walletServicePaymentMethodList.length === 0 ? (
                          <Typography sx={{ color: "var(--text-color)", opacity: 0.6 }}>
                            No Wallet Services Payment Method Added!
                          </Typography>
                        ) : (
                          <Table>
                            <TableHead>
                              <TableRow sx={tableHeadRow}>
                                <TableCell sx={tableHeadCell}></TableCell>
                                <TableCell sx={tableHeadCell}>Payment Provider Name</TableCell>
                                <TableCell sx={tableHeadCell}>Wallet Id</TableCell>
                                <TableCell sx={tableHeadCell}>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {walletServicePaymentMethodList.map(
                                (method, index) => (
                                  <TableRow key={index} sx={tableBodyRow}>
                                    <TableCell sx={tableBodyCell}>
                                      <Checkbox
                                        checked={selectedRows.includes(
                                          method.pmDetailsId
                                        )}
                                        onChange={() => {
                                          addWalletPaymentMethod(index);
                                          handleSelectRowWallet(index);
                                        }}
                                        sx={{ color: "rgba(125,125,125,0.5)", "&.Mui-checked": { color: btncolor } }}
                                      />
                                    </TableCell>
                                    <TableCell sx={tableBodyCell}>
                                      {method.paymentProviderName}
                                    </TableCell>
                                    <TableCell sx={tableBodyCell}>{method.walletId}</TableCell>
                                    <TableCell sx={tableBodyCell}>
                                      <ButtonGroup>
                                        <OutlinedButton
                                          variant="outlined"
                                          onClick={() =>
                                            handleOpenEditPaymentModal(
                                              method.pmDetailsId,
                                              index,
                                              "wallet_services"
                                            )
                                          }
                                        >
                                          Edit
                                        </OutlinedButton>
                                        <OutlinedButton
                                          variant="outlined"
                                          onClick={() =>
                                            deletePaymentMethod(
                                              method.pmDetailsId,
                                              "wallet_service"
                                            )
                                          }
                                          sx={{
                                            ml: 1,
                                          }}
                                        >
                                          Delete
                                        </OutlinedButton>
                                      </ButtonGroup>
                                    </TableCell>
                                  </TableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                        )}
                      </Box>
                    )}

                    {/* Bank Transfer Tab */}
                    {selectedChildTab === 1 && (
                      <Box sx={{ padding: 2 }}>
                        {bankTransferPaymentMethodList.length === 0 ? (
                          <Typography sx={{ color: "var(--text-color)", opacity: 0.6 }}>
                            No Bank Transfer Payment Method Added!
                          </Typography>
                        ) : (
                          <Table>
                            <TableHead>
                              <TableRow sx={tableHeadRow}>
                                <TableCell sx={tableHeadCell}></TableCell>
                                <TableCell sx={tableHeadCell}>Account Holder’s Name</TableCell>
                                <TableCell sx={tableHeadCell}>Bank Name</TableCell>
                                <TableCell sx={tableHeadCell}>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {bankTransferPaymentMethodList.map(
                                (method, index) => (
                                  <TableRow key={index} sx={tableBodyRow}>
                                    <TableCell sx={tableBodyCell}>
                                      <Checkbox
                                        checked={selectedBankRows.includes(
                                          method.pmDetailsId
                                        )}
                                        onChange={() => {
                                          addBankPaymentMethod(index);
                                          handleSelectRowBank(index);
                                        }}
                                        sx={{ color: "rgba(125,125,125,0.5)", "&.Mui-checked": { color: btncolor } }}
                                      />
                                    </TableCell>

                                    <TableCell sx={tableBodyCell}>
                                      {method.accountHolderName}
                                    </TableCell>
                                    <TableCell sx={tableBodyCell}>{method.bankName}</TableCell>
                                    <TableCell sx={tableBodyCell}>
                                      <ButtonGroup>
                                        <OutlinedButton
                                          variant="outlined"
                                          onClick={() =>
                                            handleOpenEditPaymentModal(
                                              method.pmDetailsId,
                                              index,
                                              "bank_transfer_services"
                                            )
                                          }
                                        >
                                          Edit
                                        </OutlinedButton>
                                        <OutlinedButton
                                          variant="outlined"
                                          sx={{
                                            ml: 1,
                                          }}
                                          onClick={() =>
                                            deletePaymentMethod(
                                              method.pmDetailsId,
                                              "bank_transfer"
                                            )
                                          }
                                        >
                                          Delete
                                        </OutlinedButton>
                                      </ButtonGroup>
                                    </TableCell>
                                  </TableRow>
                                )
                              )}
                            </TableBody>
                          </Table>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </>
        );

      case 2:
        return (
          <>
            <Typography sx={{ fontSize: "1.1rem", fontWeight: 700, color: "var(--text-color)", mb: 1 }} gutterBottom>
              Remarks & Auto Response
            </Typography>
            <Divider sx={{ mb: 3, borderColor: "rgba(125,125,125,0.15)" }} />

            <Typography sx={{ color: "#ef4444", fontSize: "0.85rem", mb: 2, p: 1.5, backgroundColor: "rgba(239,68,68,0.06)", borderRadius: "8px", border: "1px solid rgba(239,68,68,0.2)" }}>
              Please Note that charging the counterparty with addtional fees is
              prohibited. If such information is stated in remarks or
              auto-reply. The Ad posting function of your account may be
              permanently blocked.
            </Typography>

            <Grid container spacing={3} mt={1}>
              <Grid size={12}>
                <TextField
                  fullWidth
                  label="Remarks (Optional)"
                  name="remarks"
                  multiline
                  minRows={2}
                  value={formData.remarks}
                  onChange={handleChange}
                  sx={{ ...modernFieldStyle, "& .MuiInputBase-root": { ...modernFieldStyle["& .MuiInputBase-root"], height: "auto", minHeight: "80px" } }}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  fullWidth
                  label="Auto Reply Message (Optional)"
                  name="autoReply"
                  multiline
                  minRows={2}
                  value={formData.autoReply}
                  onChange={handleChange}
                  sx={{ ...modernFieldStyle, "& .MuiInputBase-root": { ...modernFieldStyle["& .MuiInputBase-root"], height: "auto", minHeight: "80px" } }}
                />
              </Grid>
              <Grid size={12}>
                <FormControl fullWidth sx={modernSelectStyle}>
                  <InputLabel>Region</InputLabel>
                  <Select
                    name="region"
                    label="Region"
                    value={formData.region}
                    onChange={handleChange}
                  >
                    {allRegion.map((country, idx) => (
                      <MenuItem value={country.countryName}>
                        {country.countryName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Registered Days Ago"
                  name="registeredDays"
                  type="number"
                  value={formData.registeredDays}
                  onChange={handleChange}
                  sx={modernFieldStyle}
                />
              </Grid>
              <Grid size={6}>
                <TextField
                  fullWidth
                  label="Holding More Than (USDT)"
                  name="holdingAmount"
                  type="number"
                  value={formData.holdingAmount}
                  onChange={handleChange}
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={12}>
                <Typography sx={{ fontSize: "0.9rem", fontWeight: 600, color: "var(--text-color)", mb: 0.5 }} gutterBottom>
                  Ad Status
                </Typography>
                <RadioGroup
                  row
                  value={formData.status}
                  onChange={handleChange}
                  name="status"
                  sx={{ "& .MuiFormControlLabel-label": { color: "var(--text-color)" }, "& .MuiRadio-root": { color: "rgba(125,125,125,0.5)" }, "& .MuiRadio-root.Mui-checked": { color: btncolor } }}
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="Online"
                  />
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label="Offline (activate later)"
                  />
                </RadioGroup>
              </Grid>
            </Grid>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Box sx={pageWrapper}>
        {/* Hero Banner */}
        <Box sx={{ ...heroBanner, background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)` }}>
          <Box sx={heroContent}>
            <Box sx={heroIconBadge}><PostAddIcon sx={{ color: "#fff", fontSize: 30 }} /></Box>
            <Box>
              <Typography sx={heroTitle}>Post New Ad</Typography>
              <Typography sx={heroSubtitle}>Create a buy or sell advertisement for P2P trading</Typography>
            </Box>
          </Box>
        </Box>

        {/* Main Card wrapping P2PNavbar and Stepper Content */}
        <Box sx={mainCard}>
          <P2PNavbar />

          <Box sx={{ p: { xs: 2, md: 4 } }}>
            <Box sx={{ maxWidth: 1000, mx: "auto" }}>
              <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3, "& .MuiStepLabel-label": { color: "var(--text-color)", opacity: 0.7 }, "& .MuiStepLabel-label.Mui-active": { color: "var(--text-color)", opacity: 1 }, "& .MuiStepIcon-root": { color: "rgba(125,125,125,0.3)" }, "& .MuiStepIcon-root.Mui-active": { color: btncolor }, "& .MuiStepIcon-root.Mui-completed": { color: btncolor } }}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>
                      <Typography fontSize={14}>{label}</Typography>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>

              <Box sx={stepperCard}>
                {renderStepContent()}

                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
                  <ContainedButton
                    variant="contained"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                  >
                    Back
                  </ContainedButton>
                  <ContainedButton
                    variant="contained"
                    onClick={handleNext}
                    disabled={!isStepValid()}
                  >
                    {activeStep === steps.length - 1 ? "Submit" : "Next"}
                  </ContainedButton>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Dialog
        open={paymentCreateModal}
        onClose={() => setPaymentCreateModal(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Add Payment Method
          <IconButton onClick={() => setPaymentCreateModal(false)} size="small" sx={dialogCloseBtn}><CloseIcon fontSize="small" /></IconButton>
        </DialogTitle>

        <DialogContent sx={dialogContentStyle}>
          <Box sx={{ mt: 1 }}>
            <FormControl fullWidth sx={modernSelectStyle}>
              <InputLabel>Choose Payment Method</InputLabel>
              <Select
                label="Choose Payment Method"
                value={createPaymentMethod}
                onChange={(e) => setCreatePaymentMethod(e.target.value)}
              >
                <MenuItem value="Wallet Services">Wallet Services</MenuItem>
                <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {createPaymentMethod === "Wallet Services" ? (
            <Grid container spacing={2} mt={1}>
              <Grid size={12}>
                <TextField
                  label="Payment Provider Name"
                  name="payment_provider_name"
                  value={paymentProviderNameCreate}
                  onChange={(e) => setPaymentProviderNameCreate(e.target.value)}
                  fullWidth
                  required
                  error={submitted && !formValues.payment_provider_name}
                  helperText={
                    submitted && !formValues.payment_provider_name
                      ? "Required"
                      : ""
                  }
                  onKeyDown={allowOnlyAlphabets}
                  onPaste={handlePasteOnlyAlpha}
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={{ xs: 6, md: 4 }}>
                <TextField
                  label="Phone Number"
                  name="phone_number"
                  value={phoneNumberCreate}
                  onChange={(e) => setPhoneNumberCreate(e.target.value)}
                  fullWidth
                  required
                  error={
                    submitted && !formValues.phone_number?.match(/^\d{8,15}$/)
                  }
                  helperText={
                    submitted && !formValues.phone_number?.match(/^\d{8,15}$/)
                      ? "Enter a valid phone number"
                      : ""
                  }
                  onKeyDown={allowPhoneNumber}
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={{ xs: 6, md: 4 }}>
                <TextField
                  label="Wallet ID"
                  name="wallet_id"
                  value={walletIdCreate}
                  onChange={(e) => setWalletIdCreate(e.target.value)}
                  fullWidth
                  required
                  error={submitted && !walletIdEdit}
                  helperText={submitted && !walletIdEdit ? "Required" : ""}
                  onKeyDown={allowOnlyAlphaNum}
                  onPaste={handlePaste}
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={{ xs: 6, md: 4 }}>
                <TextField
                  label="Email ID"
                  name="email_id"
                  value={emailIdCreate}
                  onChange={(e) => setEmailIdCreate(e.target.value)}
                  fullWidth
                  required
                  error={
                    submitted &&
                    !emailIdEdit?.match(
                      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                    )
                  }
                  helperText={
                    submitted &&
                    !emailIdEdit?.match(
                      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                    )
                      ? "Enter a valid email"
                      : ""
                  }
                  onKeyDown={allowEmail}
                  sx={modernFieldStyle}
                />
              </Grid>
            </Grid>
          ) : createPaymentMethod === "Bank Transfer" ? (
            <Box component="form" noValidate>
              <Grid container spacing={2} mt={1}>
                <Grid size={6}>
                  <TextField
                    label="Account Holder's Name"
                    fullWidth
                    value={userInfo.userResult.firstName}
                    disabled
                    error={!!errors.accountHolder}
                    helperText={errors.accountHolder?.message}
                    onKeyDown={allowOnlyAlphabets}
                    onPaste={handlePasteOnlyAlpha}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <TextField
                    label="IBAN / Account Number"
                    fullWidth
                    {...register("ibanNumber", {
                      required: "Required",
                      pattern: {
                        value: /^[a-zA-Z0-9\s]+$/,
                        message: "Letters and numbers are allowed",
                      },
                      maxLength: {
                        value: 40,
                        message: "Maximum 40 characters allowed",
                      },
                    })}
                    error={!!errors.ibanNumber}
                    helperText={errors.ibanNumber?.message}
                    onKeyDown={allowOnlyAlphaNum}
                    onPaste={handlePaste}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <FormControl fullWidth sx={modernSelectStyle}>
                    <InputLabel>Account Type</InputLabel>
                    <Select
                      label="Account Type"
                      {...register("accountType", { required: "Required" })}
                      value={selectedAccountType}
                      onChange={(e) => setSelectedAccountType(e.target.value)}
                    >
                      <MenuItem value="Personal Savings">
                        Personal Savings
                      </MenuItem>
                      <MenuItem value="Personal Checking">
                        Personal Checking
                      </MenuItem>
                      <MenuItem value="Business Savings">
                        Business Savings
                      </MenuItem>
                      <MenuItem value="Business Checking">
                        Business Checking
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={{ xs: 6, md: 3 }}>
                  <FormControl fullWidth sx={modernSelectStyle}>
                    <InputLabel>Code Type</InputLabel>
                    <Select
                      label="Code Type"
                      {...register("codeType", { required: "Required" })}
                      value={selectedCodeType}
                      onChange={(e) => setSelectedCodeType(e.target.value)}
                    >
                      <MenuItem value="ROUTING NO">ROUTING NO</MenuItem>
                      <MenuItem value="IFSC CODE">IFSC CODE</MenuItem>
                      <MenuItem value="SWIFT CODE">SWIFT CODE</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={{ xs: 6, md: 3 }}>
                  <TextField
                    label="Enter Code"
                    fullWidth
                    {...register("additionalCode", {
                      validate: validateBankCode,
                    })}
                    error={!!errors.additionalCode}
                    helperText={errors.additionalCode?.message}
                    onKeyDown={allowOnlyAlphaNum}
                    onPaste={handlePaste}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <TextField
                    label="Bank Name"
                    fullWidth
                    {...register("bankName", {
                      required: "Required",
                      pattern: {
                        value: /^[a-zA-Z0-9\s]+$/,
                        message: "Letters and numbers are allowed",
                      },
                      maxLength: {
                        value: 50,
                        message: "Maximum 50 characters allowed",
                      },
                    })}
                    error={!!errors.bankName}
                    helperText={errors.bankName?.message}
                    onKeyDown={allowOnlyAlphabets}
                    onPaste={handlePasteOnlyAlpha}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                  <TextField
                    label="Bank Address"
                    fullWidth
                    {...register("bankAddress", {
                      required: "Required",
                      pattern: {
                        value: /^[a-zA-Z0-9,\-\s\/]+$/,
                        message:
                          "Letters, numbers, commas, and hyphens are allowed",
                      },
                      maxLength: {
                        value: 200,
                        message: "Maximum 200 characters allowed",
                      },
                    })}
                    error={!!errors.bankAddress}
                    helperText={errors.bankAddress?.message}
                    onKeyDown={allowOnlyAlphabets}
                    onPaste={handlePasteOnlyAlpha}
                    sx={modernFieldStyle}
                  />
                </Grid>
              </Grid>
            </Box>
          ) : (
            ""
          )}
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={dialogActionsStyle}>
          <OutlinedButton
            variant="outlined"
            onClick={() => setPaymentCreateModal(false)}
          >
            Cancel
          </OutlinedButton>

          {createPaymentMethod === "Wallet Services" ? (
            <ContainedButton
              variant="contained"
              onClick={() => createWalletDetails()}
            >
              Submit
            </ContainedButton>
          ) : (
            <ContainedButton
              variant="contained"
              onClick={() => createBankDetails()}
            >
              Submit
            </ContainedButton>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={paymentEditModal}
        onClose={() => handlePaymentEditDialogClose}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          {editPaymentMethod === "Wallet Services"
            ? "Update Wallet Payment Method"
            : "Update Bank Transfer Payment Method"}
          <IconButton onClick={() => setPaymentEditModal(false)} size="small" sx={dialogCloseBtn}><CloseIcon fontSize="small" /></IconButton>
        </DialogTitle>

        <DialogContent sx={dialogContentStyle}>
          {editPaymentMethod === "Wallet Services" ? (
            <Grid container spacing={2} mt={1}>
              <Grid size={12}>
                <TextField
                  label="Payment Provider Name"
                  name="payment_provider_name"
                  value={paymentProviderNameEdit}
                  onChange={(e) => setPaymentProviderNameEdit(e.target.value)}
                  fullWidth
                  required
                  error={submitted && !formValues.payment_provider_name}
                  helperText={
                    submitted && !formValues.payment_provider_name
                      ? "Required"
                      : ""
                  }
                  onKeyDown={allowOnlyAlphabets}
                  onPaste={handlePasteOnlyAlpha}
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  label="Phone Number"
                  name="phone_number"
                  value={phoneNumberEdit}
                  onChange={(e) => setPhoneNumberEdit(e.target.value)}
                  fullWidth
                  required
                  error={
                    submitted && !formValues.phone_number?.match(/^\d{8,15}$/)
                  }
                  helperText={
                    submitted && !formValues.phone_number?.match(/^\d{8,15}$/)
                      ? "Enter a valid phone number"
                      : ""
                  }
                  onKeyDown={allowPhoneNumber}
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  label="Wallet ID"
                  name="wallet_id"
                  value={walletIdEdit}
                  onChange={(e) => setWalletIdEdit(e.target.value)}
                  fullWidth
                  required
                  error={submitted && !walletIdEdit}
                  helperText={submitted && !walletIdEdit ? "Required" : ""}
                  onKeyDown={allowOnlyAlphaNum}
                  onPaste={handlePaste}
                  sx={modernFieldStyle}
                />
              </Grid>

              <Grid size={4}>
                <TextField
                  label="Email ID"
                  name="email_id"
                  value={emailIdEdit}
                  onChange={(e) => setEmailIdEdit(e.target.value)}
                  fullWidth
                  required
                  error={
                    submitted &&
                    !emailIdEdit?.match(
                      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                    )
                  }
                  helperText={
                    submitted &&
                    !emailIdEdit?.match(
                      /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
                    )
                      ? "Enter a valid email"
                      : ""
                  }
                  onKeyDown={allowEmail}
                  sx={modernFieldStyle}
                />
              </Grid>
            </Grid>
          ) : (
            <Box component="form" noValidate>
              <Grid container spacing={2} mt={1}>
                <Grid size={6}>
                  <TextField
                    label="Account Holder's Name"
                    fullWidth
                    {...register("accountHolder", {
                      required: "Required",
                      pattern: {
                        value: /^[A-Za-z\s]+$/,
                        message: "Only alphabets and spaces are allowed",
                      },
                      maxLength: {
                        value: 40,
                        message: "Maximum 40 characters allowed",
                      },
                    })}
                    error={!!errors.accountHolder}
                    helperText={errors.accountHolder?.message}
                    onKeyDown={allowOnlyAlphabets}
                    onPaste={handlePasteOnlyAlpha}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <TextField
                    label="IBAN / Account Number"
                    fullWidth
                    {...register("ibanNumber", {
                      required: "Required",
                      pattern: {
                        value: /^[a-zA-Z0-9\s]+$/,
                        message: "Letters and numbers are allowed",
                      },
                      maxLength: {
                        value: 40,
                        message: "Maximum 40 characters allowed",
                      },
                    })}
                    error={!!errors.ibanNumber}
                    helperText={errors.ibanNumber?.message}
                    onKeyDown={allowOnlyAlphaNum}
                    onPaste={handlePaste}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <FormControl fullWidth sx={modernSelectStyle}>
                    <InputLabel>Account Type</InputLabel>
                    <Select
                      label="Account Type"
                      {...register("accountType", { required: "Required" })}
                      value={selectedAccountType}
                      onChange={(e) => setSelectedAccountType(e.target.value)}
                    >
                      <MenuItem value="Personal Savings">
                        Personal Savings
                      </MenuItem>
                      <MenuItem value="Personal Checking">
                        Personal Checking
                      </MenuItem>
                      <MenuItem value="Business Savings">
                        Business Savings
                      </MenuItem>
                      <MenuItem value="Business Checking">
                        Business Checking
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={3}>
                  <FormControl fullWidth sx={modernSelectStyle}>
                    <InputLabel>Code Type</InputLabel>
                    <Select
                      label="Code Type"
                      {...register("codeType", { required: "Required" })}
                      value={selectedCodeType}
                      onChange={(e) => setSelectedCodeType(e.target.value)}
                    >
                      <MenuItem value="ROUTING NO">ROUTING NO</MenuItem>
                      <MenuItem value="IFSC CODE">IFSC CODE</MenuItem>
                      <MenuItem value="SWIFT CODE">SWIFT CODE</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={3}>
                  <TextField
                    label="Enter Code"
                    fullWidth
                    {...register("additionalCode", {
                      validate: validateBankCode,
                    })}
                    error={!!errors.additionalCode}
                    helperText={errors.additionalCode?.message}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <TextField
                    label="Bank Name"
                    fullWidth
                    {...register("bankName", {
                      required: "Required",
                      pattern: {
                        value: /^[a-zA-Z0-9\s]+$/,
                        message: "Letters and numbers are allowed",
                      },
                      maxLength: {
                        value: 50,
                        message: "Maximum 50 characters allowed",
                      },
                    })}
                    error={!!errors.bankName}
                    helperText={errors.bankName?.message}
                    onKeyDown={allowOnlyAlphabets}
                    onPaste={handlePasteOnlyAlpha}
                    sx={modernFieldStyle}
                  />
                </Grid>

                <Grid size={6}>
                  <TextField
                    label="Bank Address"
                    fullWidth
                    {...register("bankAddress", {
                      required: "Required",
                      pattern: {
                        value: /^[a-zA-Z0-9,\-\s\/]+$/,
                        message:
                          "Letters, numbers, commas, and hyphens are allowed",
                      },
                      maxLength: {
                        value: 200,
                        message: "Maximum 200 characters allowed",
                      },
                    })}
                    error={!!errors.bankAddress}
                    helperText={errors.bankAddress?.message}
                    onKeyDown={allowOnlyAlphabets}
                    onPaste={handlePasteOnlyAlpha}
                    sx={modernFieldStyle}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>

        <Divider sx={{ borderColor: "rgba(125,125,125,0.15)" }} />
        <DialogActions sx={dialogActionsStyle}>
          <OutlinedButton onClick={() => setPaymentEditModal(false)}>
            Cancel
          </OutlinedButton>

          {editPaymentMethod === "Wallet Services" ? (
            <ContainedButton
              variant="contained"
              onClick={() => updateWalletDetails()}
            >
              Submit
            </ContainedButton>
          ) : (
            <ContainedButton
              variant="contained"
              onClick={() => updateBankDetails()}
            >
              Submit
            </ContainedButton>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={onAdPreviewModal}
        onClose={() => setOnAdPreviewModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: dialogPaper }}
      >
        <DialogTitle sx={dialogTitleStyle}>
          Confirm To Post
        </DialogTitle>
        <DialogContent sx={dialogContentStyle}>
          <Box sx={{ p: 2, borderRadius: 2 }}>
            <Stack spacing={0.2}>
              <BankDetail label="Type" value={formData.type.toUpperCase()} />
              <BankDetail label="Asset" value={formData.asset} />
              <BankDetail label="Currency" value={formData.fiat} />
              <BankDetail
                label="Price Type"
                value={formData.priceType.toUpperCase()}
              />
              <BankDetail
                label="Order Limit"
                value={`${formData.orderLimitMin} ${formData.fiat} ~ ${formData.orderLimitMax} ${formData.fiat}`}
              />
              <BankDetail
                label="Total Trading Amount"
                value={`${formData.totalAmount} ${formData.asset}`}
              />
              <BankDetail
                label="Payment Method"
                value={allPaymentMethod.join(", ")}
              />
              <BankDetail
                label="Payment Time Limit (in mins)"
                value={formData.paymentTimeLimit}
              />
              <BankDetail label="Available Region" value={formData.region} />
              <BankDetail
                label="status"
                value={formData.status == "1" ? "Online" : "Offline"}
              />

              {/* Type */}

              {/* Asset */}

              {/* Currency */}

              {/* Price Type */}

              {/* Order Limit */}

              {/* Total Trading Amount */}

              {/* <Divider sx={{ my: 2 }} /> */}
            </Stack>
          </Box>

          <Box mt={3} textAlign="center">
            <ContainedButton
              variant="contained"
              onClick={(e) => handleCreateAd()}
            >
              Confirm
            </ContainedButton>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

const pageWrapper = { px: { xs: 2, md: 4 }, py: { xs: 2, md: 3 }, backgroundColor: "var(--body-color)", color: "var(--text-color)", minHeight: "calc(100vh - 64px)" };
const heroBanner = { borderRadius: "18px", px: { xs: 3, md: 4 }, py: { xs: 3, md: 3.5 }, mb: 3, position: "relative", overflow: "hidden", boxShadow: "0 10px 30px rgba(0,0,0,0.18)" };
const heroContent = { display: "flex", alignItems: "center", gap: 2, position: "relative", zIndex: 1 };
const heroIconBadge = { width: 56, height: 56, borderRadius: "14px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(255,255,255,0.18)", border: "1px solid rgba(255,255,255,0.25)", backdropFilter: "blur(6px)", flexShrink: 0 };
const heroTitle = { fontSize: { xs: "1.4rem", md: "1.7rem" }, fontWeight: 700, color: "#fff", lineHeight: 1.15, letterSpacing: "-0.015em" };
const heroSubtitle = { fontSize: { xs: "0.82rem", md: "0.9rem" }, color: "rgba(255,255,255,0.88)", mt: 0.5 };
const mainCard = { backgroundColor: "var(--body-color-less)", borderRadius: "16px", border: "1px solid rgba(125,125,125,0.15)", boxShadow: "0 1px 3px rgba(0,0,0,0.06)", overflow: "hidden", mb: 3 };
const stepperCard = { p: { xs: 2, md: 4 } };
const modernTableContainer = { borderRadius: "12px", border: "1px solid rgba(125,125,125,0.15)", overflow: "hidden", backgroundColor: "var(--body-color-less)" };
const tableHeadRow = { backgroundColor: "var(--body-color-less2)" };
const tableHeadCell = { fontSize: "0.72rem", fontWeight: 700, color: "var(--text-color)", opacity: 0.6, textTransform: "uppercase", letterSpacing: "0.06em", py: 1.75, px: 2, borderBottom: "1px solid rgba(125,125,125,0.15)", whiteSpace: "nowrap" };
const tableBodyRow = { transition: "background-color 0.15s ease", "&:hover": { backgroundColor: "rgba(125,125,125,0.04)" }, "&:last-child td": { borderBottom: 0 } };
const tableBodyCell = { py: 1.65, px: 2, fontSize: "0.85rem", color: "var(--text-color)", borderBottom: "1px solid rgba(125,125,125,0.08)" };
const dialogPaper = { borderRadius: "16px", backgroundColor: "var(--popupbody-color)", color: "var(--text-color)", boxShadow: "0 24px 60px rgba(0,0,0,0.28)" };
const dialogTitleStyle = { textAlign: "center", fontWeight: 700, fontSize: "1.1rem", py: 2.25, color: "var(--text-color)", backgroundColor: "var(--popupheader-color)", position: "relative" };
const dialogCloseBtn = { position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-color)", opacity: 0.6 };
const dialogContentStyle = { pt: 2.5, pb: 2, px: { xs: 2.5, md: 3 }, backgroundColor: "var(--popupbody-color)" };
const dialogActionsStyle = { px: 3, py: 2, backgroundColor: "var(--popupbody-color)", justifyContent: "flex-end", gap: 1 };
const modernFieldStyle = { "& .MuiInputBase-root": { borderRadius: "10px", backgroundColor: "var(--body-color-less2)", color: "var(--text-color)" }, "& .MuiInputBase-input": { color: "var(--text-color)" }, "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" }, "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.45)" }, "& .MuiInputLabel-root": { color: "var(--text-color)", opacity: 0.7 }, "& .MuiInputLabel-root.Mui-focused": { color: "var(--text-color)" }, "& .MuiSelect-icon": { color: "var(--text-color)" } };
const modernSelectStyle = { ...modernFieldStyle, "& .MuiSelect-select": { color: "var(--text-color)" } };

export default P2PPostAd;
